import { useState, useEffect } from 'react';

/**
 * Returns `true` when the viewport is at least `minWidth` px wide.
 *
 * Uses `matchMedia` for zero-cost reactivity — no resize polling. Defaults to
 * `true` during SSR so the pre-rendered markup includes the desktop nav.
 */
export function useMediaQuery(minWidth: number): boolean {
  // Match the server's desktop-first markup during hydration. The effect then
  // applies the real viewport value without asking React to discard the SSG DOM.
  const [matches, setMatches] = useState(true);

  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${minWidth}px)`);
    setMatches(mql.matches);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [minWidth]);

  return matches;
}
